import React, {useState} from "react";
import myCardStyle from "./MyCards.module.css"
import Style from "../Style.module.css";
import EditComponent from "./EditComponent";
import CloseComponent from "./CloseComponent";
import SaveComponent from "./SaveComponent";
import * as AssetsService from "../../api/AssetsService";
import {Form} from "react-bootstrap";
import {useTranslation} from "react-i18next";

export default function MyCardsPrivateNote(props) {
    const [edit, setEdit] = useState(false)
    const [newText, setNewText] = useState(props.text)
    const { t } = useTranslation('translation', { keyPrefix: 'privateNote' });

    function startEdit() {
        setEdit(true)
    }

    function resolveText(evt) {
        setNewText(evt.target.value)
    }

    function closeWithoutSave() {
        setEdit(false)
        setNewText(props.text)
    }

    function saveNewNoteText() {
        AssetsService.postPrivateNote(
            props.cellNumber,
            newText,
            () => {
                props.fetchNotes()
                setEdit(false)
            },
            () => {
                window.alert(t('error'))
            }
        )
    }

    return (
        <div>
            <div className={myCardStyle.mentorNoteCard}>
                <div className={myCardStyle.mentorNoteTitleRow}>
                    <div className={Style.h5Heading}>{t('cell')} {props.cellNumber}:</div>
                    <div className={myCardStyle.mentorNoteTextContainer}>
                        {edit ?
                            <>
                                <CloseComponent actOnClick={closeWithoutSave}
                                                toolTipText={t('exitNoSave')}/>
                                <SaveComponent actOnClick={() => {
                                    saveNewNoteText()
                                }}
                                               toolTipText={t('saveChanges')}/>
                            </>
                            : <>
                                <EditComponent openOnClick={startEdit} toolTipText={t('editText')}/>
                            </>

                        }
                    </div>

                </div>
                <Form.Control
                    readOnly={!edit}
                    style={{
                        minHeight: '110px',
                        overflowY: "scroll",
                        backgroundColor: !edit ? '#f0f0f5' : "white",
                        marginBottom: "1px"
                    }}
                    as="textarea"
                    onChange={e => resolveText(e)}
                    value={newText}
                    onClick={() => {setEdit(true)}}
                />

            </div>
        </div>

    )
}